import { defineMessages } from 'react-intl';

export const giftCardCheckoutFormMessages = defineMessages({
  formSubmissionError: {
    defaultMessage: 'Make sure all fields are correct to continue.',
    description: 'Gift Card Checkout Screen | Form submission error',
  },
});
